/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_TitleInputs */

const en_notifications_title = /** @type {(inputs: Notifications_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications`)
};

const id_notifications_title = /** @type {(inputs: Notifications_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifikasi`)
};

/** @type {(inputs: Notifications_TitleInputs) => LocalizedString} */
const es_notifications_title = en_notifications_title;

/** @type {(inputs: Notifications_TitleInputs) => LocalizedString} */
const fr_notifications_title = en_notifications_title;

/** @type {(inputs: Notifications_TitleInputs) => LocalizedString} */
const de_notifications_title = en_notifications_title;

/** @type {(inputs: Notifications_TitleInputs) => LocalizedString} */
const ja_notifications_title = en_notifications_title;

/** @type {(inputs: Notifications_TitleInputs) => LocalizedString} */
const zh_notifications_title = en_notifications_title;

/** @type {(inputs: Notifications_TitleInputs) => LocalizedString} */
const ar_notifications_title = en_notifications_title;

/** @type {(inputs: Notifications_TitleInputs) => LocalizedString} */
const it_notifications_title = en_notifications_title;

/** @type {(inputs: Notifications_TitleInputs) => LocalizedString} */
const ru_notifications_title = en_notifications_title;

/** @type {(inputs: Notifications_TitleInputs) => LocalizedString} */
const pt_notifications_title = en_notifications_title;

/** @type {(inputs: Notifications_TitleInputs) => LocalizedString} */
const ko_notifications_title = en_notifications_title;

/**
* | output |
* | --- |
* | "Notifications" |
*
* @param {Notifications_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const notifications_title = /** @type {((inputs?: Notifications_TitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_TitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notifications_title(inputs)
	if (locale === "es") return es_notifications_title(inputs)
	if (locale === "fr") return fr_notifications_title(inputs)
	if (locale === "de") return de_notifications_title(inputs)
	if (locale === "ja") return ja_notifications_title(inputs)
	if (locale === "zh") return zh_notifications_title(inputs)
	if (locale === "ar") return ar_notifications_title(inputs)
	if (locale === "id") return id_notifications_title(inputs)
	if (locale === "it") return it_notifications_title(inputs)
	if (locale === "ru") return ru_notifications_title(inputs)
	if (locale === "pt") return pt_notifications_title(inputs)
	return ko_notifications_title(inputs)
});